// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"style_menuIcon__1b2tohUCwajhKDwYfKvX4y","disabledItem":"style_disabledItem__35Ux2LQwZD_gvRqZxyEECI"};